import React from "react";
import { ScrollRestoration } from "react-router-dom";
import NavBar from "../components/NavBar/navBar.component";
import Hero from "../components/Hero/hero.component";
import Features from "../components/Features/features.component";
import Pricing from "../components/Pricing/pricing.component";
import Footer from "../components/Footer/footer.component";
import Testimonials from "../components/Testimonials/testimonials.component";
import FAQs from "../components/FAQs/faqs.component";
// import Brands from "../components/Associated Brands/brands.component";

const Home = () => {
  return (
    <div className="font-inter">
      <ScrollRestoration/>
      <NavBar/>
      <Hero/>
      <Features/>
      <Testimonials/>
      {/* <Brands/> */}
      <Pricing/>
      <FAQs/>
      <Footer/>
    </div>
  );
}

export default Home;
